module.exports = __webpack_public_path__ + "static/img/v21-1.4ca135f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21-1.png
// module id = tjKG
// module chunks = 1